var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { SliceEventList } from '../entities/slice-event-list';
import { classNames } from '@shapeable/utils';
import { useLang } from '../hooks/use-lang';
import { SliceHeaderDivider } from './slice-header-divider';
import { useCurrentEvents } from '../hooks/use-events';
var cls = classNames('slice-current-events');
export var SliceCurrentEventsDefaultProps = {
  title: 'Current Event',
  titleMultiple: 'Current Events'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EventsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Events: styled(SliceEventList)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), EventsStyles)
};
export var SliceCurrentEvents = function (props) {
  var className = props.className,
    entity = props.entity,
    title = props.title,
    titleMultiple = props.titleMultiple;
  var events = useCurrentEvents();
  var t = useLang();
  if (!events.length) {
    return null;
  }
  var defaultTitle = t(events.length > 1 ? titleMultiple : title);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(SliceHeaderDivider, null, entity.title || defaultTitle), React.createElement(My.Events, {
    events: events
  }));
};
SliceCurrentEvents.defaultProps = SliceCurrentEventsDefaultProps;
SliceCurrentEvents.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;